import { createContext } from 'react';

import { SecurityContextType } from './security.types';

/**
 * React Context for security state and functions.
 */
export const SecurityContext = createContext<SecurityContextType | undefined>(
  undefined
);
